{
  "links" : {
    "triggerLinksDescription" : "Trigger-lenker Aktivere Du for å sette lenker Indre SMS meldinger og Gmail, som Aktivere Du for å spore spesifikke kundeaktiviteter og trigger hendelser basert På Når Lenken klikkes.",
    "enterName" : "Skriv inn navn",
    "enterLinkURL" : "Skriv inn Link URL",
    "save" : "Arkivere",
    "cancel" : "Kansellere",
    "delete" : "Slett",
    "aboutToDeleteLink" : "`Du're Om for å slette ${deleteRowName} trigger Lenke. Slettet Lenke kan ikke gjenopprettes, er du sikker på at du vil Fortsette?`",
    "noTriggerLinksFound" : "Ingen trigger-lenker funnet",
    "getStartedByAddingNewTriggerLinks" : "Kom i gang Ved å legge til ny Trigger-lenker",
    "newTriggerLink" : "Ny trigger- Lenke",
    "searchNoMatch" : "Søket ditt samsvarte ikke med noen trigger Lenke.",
    "link" : "Lenke",
    "addLink" : "Legge til til Lenke",
    "linkURL" : "Link URL",
    "name" : "Navn",
    "pleaseEnterNonEmptyLinkName" : "Skriv inn et ikke-tomt Lenke-navn",
    "pleaseEnterURL" : "Skriv inn URL",
    "actions" : "aktiviteter",
    "linkKey" : "Lenke Viktig",
    "keyCopied" : "Viktig kopiert"
  }
}
